/* Mona Home — scroller arrows + reduced-motion video handling */
(function () {
  'use strict';

  /* Horizontal scroller arrow controls */
  document.querySelectorAll('[data-mona-scroller-group]').forEach(function (group) {
    var scroller = group.querySelector('[data-mona-scroller]');
    var prev = group.querySelector('[data-mona-scroll-prev]');
    var next = group.querySelector('[data-mona-scroll-next]');
    if (!scroller) return;

    function amount() {
      var first = scroller.querySelector(':scope > *');
      return first ? first.offsetWidth + 24 : scroller.clientWidth * 0.8;
    }
    function update() {
      if (prev) prev.disabled = scroller.scrollLeft <= 4;
      if (next) next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: amount(), behavior: 'smooth' }); });
    scroller.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* Respect prefers-reduced-motion: pause autoplay videos */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video[autoplay][data-mona-video]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }
})();
